import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {gql, useLazyQuery} from "@apollo/client/index";
import ContactsForm from "../../Customer/ContactsForm";
import Typography from "@material-ui/core/Typography/Typography";
import Alert from "@material-ui/lab/Alert/Alert";
import * as ReactGA from "react-ga";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            marginBottom: 20,
            border: '1px dotted #ccc',
            padding: 15,
        },
        header: {
            marginTop: 15
        },
        headerMobile: {
            marginBottom: 5
        },
        subHeader: {
            marginBottom: 5
        },
        subHeaderMobile: {
            marginBottom: 10
        }
    }
});

const SEND_CONTACT_INFORMATION = gql`
  query($requestCode: String, $updateHash: String, $contactInformationInput: ContactInformationInput) {
    sendContactInformation(requestCode: $requestCode, updateHash: $updateHash,
        contactInformationInput: $contactInformationInput) {
        message
    }
  }
`;


export default function OfferContactInformation(props) {

    const classes = useStyles();

    let [sendContactInformation, {loading, data, error}]
        = useLazyQuery(SEND_CONTACT_INFORMATION);

    if (!loading && data) {
        props.onActionComplete();
        data = null;
    }

    const handleContactInformation = (values) => {
        sendContactInformation({variables: {
                requestCode: props.request.code,
                updateHash: props.request.updateHash,
                contactInformationInput: values
            }});

        ReactGA.event({
            category: 'User',
            action: 'offer_contacts_sent'
        });
    };

    return <>
        <Typography variant={"h6"} className={classes.header}>
            <Typography className={classes.subHeader}>
                Leave us your contact information so Dealer can stay in-touch with you for this reservation.
            </Typography>
        </Typography>
        <div className={classes.root}>

            {error ? <Alert severity="warning">{error.message}</Alert> : null }
            {data ? '' :
                <>
                    <ContactsForm loading={loading} handleContactInformation={handleContactInformation}/>
                </>
            }
        </div></>;
}
